"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrevButton = void 0;
const decorators_js_1 = require("lit/decorators.js");
const icon_names_1 = require("@/components/common/icon/icon-names");
const icon_button_utils_1 = require("@/components/common/icon-button/icon-button.utils");
let PrevButton = class PrevButton extends (0, icon_button_utils_1.iconActionElement)({
    event: 'prev',
    icon: icon_names_1.ICON_NAMES.PREVIOUS,
    ariaLabel: '이전',
}) {
    constructor() {
        super(...arguments);
        /** 스크롤 힌트처럼 놓인 자리에 따라 크기가 달라지므로 크기 단계를 받는다. */
        this.size = 'medium';
    }
};
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], PrevButton.prototype, "size", void 0);
PrevButton = __decorate([
    (0, decorators_js_1.customElement)('mm-prev-button')
], PrevButton);
exports.PrevButton = PrevButton;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJldi1idXR0b24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJwcmV2LWJ1dHRvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSxxREFBMkQ7QUFJM0Qsb0VBQWdFO0FBQ2hFLHlGQUFxRjtBQUc5RSxJQUFNLFVBQVUsR0FBaEIsTUFBTSxVQUFXLFNBQVEsSUFBQSxxQ0FBaUIsRUFBQztJQUNoRCxLQUFLLEVBQUUsTUFBTTtJQUNiLElBQUksRUFBRSx1QkFBVSxDQUFDLFFBQVE7SUFDekIsU0FBUyxFQUFFLElBQUk7Q0FDaEIsQ0FBQztJQUpLOztRQUtMLCtDQUErQztRQUNKLFNBQUksR0FBbUIsUUFBUSxDQUFBO0lBQzVFLENBQUM7Q0FBQSxDQUFBO0FBRDRDO0lBQTFDLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDO3dDQUFnQztBQU4vRCxVQUFVO0lBRHRCLElBQUEsNkJBQWEsRUFBQyxnQkFBZ0IsQ0FBQztHQUNuQixVQUFVLENBT3RCO0FBUFksZ0NBQVUifQ==